import React from 'react';
import PropTypes from 'prop-types';
import RatingStats from './RatingStats';
import style from './WidgetRatings.scss';

const SHOW_RATING_THRESHOLD = 4.0;
const SHOW_REVIEW_COUNT_THRESHOLD = 0;

const WidgetRatings = ({ ratings }) => {
  const filteredRatings = ratings.filter(
    rating =>
      rating != null &&
      rating.reviewCount > SHOW_REVIEW_COUNT_THRESHOLD &&
      rating.rating > SHOW_RATING_THRESHOLD
  );
  if (filteredRatings.length === 0) {
    return null;
  }
  return (
    <ul className={style['widget-ratings']}>
      {filteredRatings.map(rating => (
        <li key={rating.serviceType} className={style['widget-ratings__item']}>
          <RatingStats {...rating} />
        </li>
      ))}
    </ul>
  );
};

WidgetRatings.propTypes = {
  ratings: PropTypes.arrayOf(
    PropTypes.shape({
      serviceType: PropTypes.string.isRequired,
      reviewCount: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default WidgetRatings;
